<template>
  <div class="container">
    <AboutSection avatar_name="avatar.jpg" aboutJsonName="about.json" />
  </div>
</template>
<script>
import AboutSection from "../components/AboutSection.vue";
export default {
  name: "About",
  components: {
    AboutSection
  }
};
</script>
